export default __webpack_public_path__ + "static/media/logos.a235efef.png";